import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { SubmissionError, initialize, change, untouch} from 'redux-form'
import { saveIncomes, getNextStep, submitForm, stopSubmitForm } from '../actions/users';
import { getErrorsApiToReduxForm } from '../utils/utils.js';
import IncomesForm from '../components/IncomesForm.js';

const mapStateToProps = (state) => {

    return {
        isLoading: state.users.isLoading
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setDefaultValue(values) {
            dispatch(initialize('IncomesForm', values, null));
        },
        deleteReduxFormField(fieldName){
            dispatch(change('IncomesForm', fieldName, null));
            dispatch(untouch('IncomesForm', fieldName));
        },
        saveIncomes(values, dispatch) {
            dispatch(submitForm())
            return dispatch(saveIncomes(values)).then((result) => {
                if (result.payload.status !== 200) {
                    dispatch(stopSubmitForm());
                    throw new SubmissionError ({...getErrorsApiToReduxForm(result.payload.response.data), _error: 'Revisá los campos indicados.'});
                } else {
                    dispatch(getNextStep()).then((result) => {
                        if (typeof(result.payload.data.endpoint) !== 'undefined') {
                            sessionStorage.setItem('endpoint',result.payload.data.endpoint);
                            dispatch(stopSubmitForm());
                            browserHistory.push(result.payload.data.endpoint)
                        }
                    });
                }
            });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IncomesForm);


/** WEBPACK FOOTER **
 ** ./src/containers/IncomesFormContainer.js
 **/